import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type CookieConsentPreferences = {
  analytics: boolean;
};

type CookieConsentStore = {
  consent: CookieConsentPreferences | null;
  setConsent: (preferences: CookieConsentPreferences) => void;
  acceptAll: () => void;
  rejectAll: () => void;
  hasConsented: () => boolean;
};

export const useCookieConsentStore = create<CookieConsentStore>()(
  persist(
    (set, get) => ({
      consent: null,
      setConsent: (preferences) => set({ consent: preferences }),
      acceptAll: () => set({ consent: { analytics: true } }),
      rejectAll: () => set({ consent: { analytics: false } }),
      hasConsented: () => get().consent !== null,
    }),
    {
      name: 'cookie-consent-storage',
    },
  ),
);
